'use client';

import Loader from '@/components/ui/Loader';

const Loading = () => {
    return (
        <div className="w-full h-[40vh] flex justify-center items-center">
            <Loader />
        </div>
    );
};

export default Loading;
